import channelEcommercePlatformView from "./ChannelEcommercePlatformView";

export default channelEcommercePlatformView;
